// Domain
import { CustomerDocumentWealthRepository } from '../../../domain/repositories/customer-document-wealth-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CustomerDocumentWealthDummyRepository
implements CustomerDocumentWealthRepository {
  update_bank_statement(): Promise<void> {
    return Promise.resolve();
  }

  update_proof_of_address(): Promise<void> {
    return Promise.resolve();
  }
}
